import { Stack, Typography } from '@mui/material';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import { ReactNode } from 'react';

export interface Props {
  title: ReactNode;
  icon?: ReactNode;
  to?: string;
}

export const BlockHeading = ({ icon, title, to }: Props) => (
  <Stack direction="row" alignItems="center" gap={1} sx={{ minWidth: 0 }}>
    {icon}
    <Typography variant="subtitle1" fontWeight={600} noWrap>
      {title}
    </Typography>
    {to && <ArrowForwardRoundedIcon fontSize="small" sx={{ opacity: 0.6 }} />}
  </Stack>
);
